import { render, staticRenderFns } from "./AppVersion.vue?vue&type=template&id=3408cf6e&"
import script from "./AppVersion.vue?vue&type=script&lang=ts&"
export * from "./AppVersion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports